import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "@/store/store";
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";


// 販売カテゴリー一覧を格納する


@Module({
    name: "CategoriesStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class CategoriesStore extends VuexModule {

    // state
    private _apiResponse: CMS.Category[] = [];
    private _categoryById: { [categoryId: number]: CMS.Category } = {};

    // getter
    get all(): CMS.Category[] {
        return this._apiResponse || [];
    }

    get categoryById(): { [p: number]: CMS.Category } {
        return this._categoryById;
    }

    get firstCategoryId(): number {
        return this._apiResponse.map(v => v.id)[0] || -1;
    }

    get lastCategoryId(): number {
        const ids: number[] = this._apiResponse.map(v => v.id);
        return ids.length > 0 ? ids[ids.length - 1] : -1;
    }

    @Action
    public async init(menuId: number) {
        const response: CMS.Category[] = (await CmsApiClient.getCategories(menuId));
        this.refresh(response);
    }

    @Action
    private refresh(response: CMS.Category[]) {
        this.initVals();
        this.setResponse(response);
        for (let i = 0; i < response.length; i++) {
            this.setCategoryByid(response[i]);
        }
    }

    @Mutation
    private initVals() {
        this._apiResponse = [];
        this._categoryById = {};
    }

    @Mutation
    private setResponse(response: CMS.Category[]) {
        this._apiResponse = response;
    }

    @Mutation
    private setCategoryByid(category: CMS.Category) {
        Vue.set(this._categoryById, category.id, category);
    }

    @Action
    public async create(category: CMS.Category) {
        const added = this._apiResponse.concat([category]);
        this.refresh(added);
        await CmsApiClient.createCategory(category);
        await this.init(category.menu_id);
    }

    @Action
    public async edit(category: CMS.Category) {
        const edited = this._apiResponse.map(v => (v.id == category.id) ? category : v);
        this.refresh(edited);
        await CmsApiClient.editCategory(category);
        this.init(category.menu_id);
    }


    @Action
    public async localSort(sortedIds: number[]) {
        const sorted: CMS.Category[] = sortedIds.map(id => this._categoryById[id]);
        this.refresh(sorted);
    }

    @Action
    public async applySort() {
        const sortedIds: number[] = this._apiResponse.map(v => v.id);
        const menuId:number = this.all[0].menu_id;
        await CmsApiClient.sortCategory(menuId, sortedIds);
        this.init(menuId);
    }

    @Action
    public async delete(categoryId: number) {
        const target = this.categoryById[categoryId];
        const deleted = this._apiResponse.filter(v => v.id != categoryId);
        this.refresh(deleted);
        await CmsApiClient.deleteCategory(target);
        await this.init(target.menu_id);
    }

}

export default getModule(CategoriesStore);
